import { render, staticRenderFns } from "./ConfirmNote.vue?vue&type=template&id=1ae9704e&scoped=true&"
import script from "./ConfirmNote.vue?vue&type=script&lang=js&"
export * from "./ConfirmNote.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmNote.vue?vue&type=style&index=0&id=1ae9704e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9704e",
  null
  
)

export default component.exports